export default __webpack_public_path__ + "static/091-a2a215391b5c84b46459eb09cf3aa771.jpg";